"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.nav.dashboard': 'Panel',
    'socialMediaPlan.nav.channels': 'Canales',
    'socialMediaPlan.nav.analytics': 'Analytics',
};
